import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { paymentConfigList, delepaymentConfig } from "@/api/pakgConfig/paymentConfig";
import addpaymentConfigs from "./components/addpaymentConfig";
import { serchSelect } from "@/mixins/index"; // import clipboard from '@/utils/clipboard'

export default {
  name: "paymentCenterPakgConfig",
  components: {
    addpaymentConfigs: addpaymentConfigs
  },
  mixins: [serchSelect],
  data: function data() {
    return {
      reqLoading: false,
      minWidth: 200,
      searchgames: [],
      searchplatforms: [],
      searchchannels: [],
      searchpkgs: [],
      tableTitle: [],
      gameId: "",
      value1: "",
      total: 0,
      pagrSize: 10,
      disabled: true,
      sels: [],
      selsString: "",
      addpaymentConfigs: false,
      searchData: {
        page: 1,
        page_size: 10,
        game: "",
        platform: "",
        channel: "",
        pkg: ""
      },
      showing: false,
      id: "",
      tableData: [],
      tableLtv: [],
      tableDate: "",
      show: false,
      echarts: false,
      dates: [],
      new_device_num: [],
      new_account_num: [],
      active_account_num: [],
      day_account: [],
      recharge_account_num: [],
      recharge_account_amount: [],
      pay_account_percent: [],
      pay_account_arpu: [],
      pay_account_arppu: [],
      login_account_num: []
    };
  },
  created: function created() {},
  methods: {
    searchClick: function searchClick(e) {
      var _this = this;

      this.searchData.kind = 1;
      this.reqLoading = true;
      this.searchData.page = e;
      paymentConfigList(this.searchData).then(function (res) {
        if (res.status == 200) {
          var list = ['n_game', 'n_platform', 'n_channel', 'n_pkg', 'o_game', 'o_platform', 'o_channel', 'o_pkg'];
          _this.tableData = res.data.data.length ? _this.$utils.dataConversion(res.data.data, list) : [];
          _this.total = res.data.total - 0 || 0;
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this2 = this;

      this.sels = [];
      val.forEach(function (e) {
        _this2.sels.push(e.id);
      });
      this.selsString = this.sels.toString();
    },
    handleSource: function handleSource(id) {
      var _this3 = this;

      this.addpaymentConfigs = true;
      this.showing = true;
      this.$nextTick(function () {
        _this3.$refs.addpaymentConfigs.init(id);
      });
    },
    changeShow: function changeShow(val) {
      this.showing = val;
    },
    handleDelete: function handleDelete(id) {
      var _this4 = this;

      this.$confirm("此操作将删除该配置, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                delepaymentConfig({
                  id: id
                }).then(function (res) {
                  _this4.searchClick(_this4.searchData.page);
                });

                _this4.$message({
                  type: "success",
                  message: "删除成功!"
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }
};